import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { VendorDetailsPage } from './vendor-details.page';

import { PipesModule } from '../../shared/pipes/pipes.module';

import { AnimatedImageComponentModule } from '../../shared/components/animated-image/animated-image.module';
import { AreaDateTimePickerComponentModule } from '../../shared/components/area-date-time-picker/area-date-time-picker.module';
import { BrowserFooterComponentModule } from '../../shared/components/browser-footer/browser-footer.module';
import { BrowserHeaderComponentModule } from '../../shared/components/browser-header/browser-header.module';
import { GroceryCategoryItemsHorizontalListComponentModule } from '../../shared/components/grocery-category-items-horizontal-list/grocery-category-items-horizontal-list.module';
import { GroceryItemComponentModule } from '../../shared/components/grocery-item/grocery-item.module';
import { MultidimensionalRatingComponentModule } from '../../shared/components/multidimensional-rating/multidimensional-rating.module';
import { VendorGroceryCategoriesComponentModule } from '../../shared/components/vendor-grocery-categories/vendor-grocery-categories.module';
import { VendorMenuGroupsComponentModule } from '../../shared/components/vendor-menu-groups/vendor-menu-groups.module';
import { ViewOrderButtonComponentModule } from '../../shared/components/view-order-button/view-order-button.module';

import { VendorDetailsPageRoutingModule } from './vendor-details-routing.module';

import { SwiperModule } from 'swiper/angular';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    PipesModule,
    VendorDetailsPageRoutingModule,
    MultidimensionalRatingComponentModule,
    AnimatedImageComponentModule,
    ViewOrderButtonComponentModule,
    AreaDateTimePickerComponentModule,
    TranslateModule.forChild(),
    VendorMenuGroupsComponentModule,
    VendorGroceryCategoriesComponentModule,
    GroceryItemComponentModule,
    GroceryCategoryItemsHorizontalListComponentModule,
    BrowserHeaderComponentModule,
    BrowserFooterComponentModule,
    SwiperModule,
  ],
  declarations: [VendorDetailsPage],
})
export class VendorDetailsPageModule {}
